import {FunctionComponent} from "react";
import RemoveConfirmationDialog from "./remove-confirmation";
import ConfirmationDialog from "./confirmation";
import DownloadCodeDialog from "./download-code";
import ViewInstallationGuideDialog from "./view-installation-guide";


const ApplicationDialogs: FunctionComponent = () => {


    return (
        <>
            <ConfirmationDialog/>
            <DownloadCodeDialog/>
            <RemoveConfirmationDialog/>
            <ViewInstallationGuideDialog/>
        </>
    );
}


export default ApplicationDialogs;
